// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconStandard_qoKbt {
    height : 24px;
    width: 24px;
    margin-right: 10px;
    margin-top: 2px;
}

.iconCentered_TwEMU {
    height : 24px;
    width: 24px;
    margin: 27px;
}

.blueCircle_EEbwI{
    height: 80px;
    width: 80px;
    background: rgba(22, 97, 215, 0.25);
    border-radius: 50%;
    border: 1px solid #1661D7;
    margin-right: 10px;
    flex-shrink: 0
}

.mapKeyDiv_dqpLf {
    margin-top: 10px;
}

.statesDescriptionHeader_yJglW{
    margin-top: 10px;
}

.stateDescription_wt03I{
    margin: var(--size-padSmall) 0 0 0 !important;
}

.contentArea_pg3pU {
    background: #f3f5f6;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/mapKey/MapKey.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".iconStandard {\n    height : 24px;\n    width: 24px;\n    margin-right: 10px;\n    margin-top: 2px;\n}\n\n.iconCentered {\n    height : 24px;\n    width: 24px;\n    margin: 27px;\n}\n\n.blueCircle{\n    height: 80px;\n    width: 80px;\n    background: rgba(22, 97, 215, 0.25);\n    border-radius: 50%;\n    border: 1px solid #1661D7;\n    margin-right: 10px;\n    flex-shrink: 0\n}\n\n.mapKeyDiv {\n    margin-top: 10px;\n}\n\n.statesDescriptionHeader{\n    margin-top: 10px;\n}\n\n.stateDescription{\n    margin: var(--size-padSmall) 0 0 0 !important;\n}\n\n.contentArea {\n    background: #f3f5f6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconStandard": `iconStandard_qoKbt`,
	"iconCentered": `iconCentered_TwEMU`,
	"blueCircle": `blueCircle_EEbwI`,
	"mapKeyDiv": `mapKeyDiv_dqpLf`,
	"statesDescriptionHeader": `statesDescriptionHeader_yJglW`,
	"stateDescription": `stateDescription_wt03I`,
	"contentArea": `contentArea_pg3pU`
};
export default ___CSS_LOADER_EXPORT___;
